module.exports = __webpack_public_path__ + "media/modals/img1-f31bed01.svg";